import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GraduationCap, LogIn } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { Reveal, FadeIn } from "../components/Motion";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function StudentLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ student_id: "", name: "", phone: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/students/login", form);
      localStorage.setItem("smct_student", JSON.stringify(data));
      navigate("/student-dashboard");
    } catch (err) {
      setError(formatApiError(err, "Invalid Student ID, Name or Mobile Number"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="student-login-page" className="px-4 pb-24 pt-32 sm:px-6 lg:pt-40">
      <div className="mx-auto max-w-md">
        <FadeIn>
          <p className="text-center font-mono text-xs uppercase tracking-[0.25em] text-terracotta-dark">Student Portal</p>
        </FadeIn>
        <h1 className="mt-4 text-center font-serif text-4xl font-bold tracking-tight text-forest-deep">
          <Reveal y={24}>Welcome back,</Reveal>
          <Reveal y={24} delay={0.1}>
            <span className="italic text-terracotta">dear student.</span>
          </Reveal>
        </h1>

        <Reveal delay={0.2}>
          <form onSubmit={submit} data-testid="student-login-form" className="mt-10 rounded-3xl border border-forest/10 bg-white p-8 shadow-sm sm:p-10">
            <div className="flex justify-center">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-forest text-cream">
                <GraduationCap className="h-7 w-7" />
              </span>
            </div>
            <div className="mt-8 space-y-5">
              <div>
                <Label htmlFor="student-id">Student ID</Label>
                <Input id="student-id" data-testid="student-id-input" value={form.student_id} onChange={set("student_id")} placeholder="e.g. SMCT-2026-001" className="mt-2 h-11" />
              </div>
              <div>
                <Label htmlFor="student-name">Full Name</Label>
                <Input id="student-name" data-testid="student-name-input" value={form.name} onChange={set("name")} placeholder="As given at admission" className="mt-2 h-11" />
              </div>
              <div>
                <Label htmlFor="student-phone">Registered Mobile</Label>
                <Input id="student-phone" data-testid="student-phone-input" value={form.phone} onChange={set("phone")} placeholder="+91 ..." className="mt-2 h-11" />
              </div>
              {error && (
                <p data-testid="student-login-error" className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p>
              )}
              <Button type="submit" disabled={loading} data-testid="student-login-submit-button" className="w-full rounded-full bg-forest py-6 font-display text-cream hover:bg-forest-deep disabled:opacity-60">
                {loading ? "Signing in..." : (<>View My ID Card <LogIn className="ml-2 h-4 w-4" /></>)}
              </Button>
            </div>
          </form>
        </Reveal>
      </div>
    </div>
  );
}
